$(document).ready(function () {
    $('.quote-btn').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        const nextURL = '/get-quote';
        const nextTitle = 'Get a quote';
        const nextState = {};
        // This will create a new entry in the browser's history, without reloading
        window.history.pushState(nextState, nextTitle, nextURL);
        // This will replace the current entry in the browser's history, without reloading
        window.history.replaceState(nextState, nextTitle, nextURL);
        //Stop the page from being scrollable behind the modal
        body.style.overflow = 'hidden';

        // Opening modal
        //$('.get-quote-modal').css('display', 'flex');
        $('.get-quote-modal').css('display', 'flex').hide().fadeIn();
        $('.get-quote-container').show();
        $('.go-next').prop('disabled', true);
        $('.submit-btn').prop('disabled', true);

        $('.step-1').removeClass('completed');
        $('.step-2').removeClass('completed');
        $('.step-3').removeClass('completed');
        $('.step-2').removeClass('active');
        $('.step-3').removeClass('active');
    });
    // Toggle service menu items
    $('.port-of-destination-svg').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        $('.port-of-destination-svg').addClass('active-service');
        $('.exporter').removeClass('active-service');
        $('.port-of-loading').removeClass('active-service');

        $('.port-of-destination-description').show();
        $('.port-of-loading-description').hide();
        $('.exporter-description').hide();
        $('.buyer-description').hide();
    });
    $('.exporter').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        $('.exporter').addClass('active-service');
        $('.port-of-destination-svg').removeClass('active-service');
        $('.port-of-loading').removeClass('active-service');
        $('.buyer').removeClass('active-service');

        $('.port-of-destination-description').hide();
        $('.port-of-loading-description').hide();
        $('.exporter-description').show();
        $('.buyer-description').hide();
    });
    $('.port-of-loading').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        $('.port-of-loading').addClass('active-service');
        $('.port-of-destination-svg').removeClass('active-service');
        $('.exporter').removeClass('active-service');
        $('.buyer').removeClass('active-service');

        $('.port-of-destination-description').hide();
        $('.port-of-loading-description').show();
        $('.exporter-description').hide();
        $('.buyer-description').hide();
    });
    $('.buyer').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        $('.buyer').addClass('active-service');
        $('.port-of-destination-svg').removeClass('active-service');
        $('.exporter').removeClass('active-service');
        $('.port-of-loading').removeClass('active-service');

        $('.port-of-destination-description').hide();
        $('.port-of-loading-description').hide();
        $('.exporter-description').hide();
        $('.buyer-description').show();
    });
});
